<script>
import MainLayout from '../layouts/mainLayout'
import { RoleFlagCheck } from '@/utils/RoleFlagCheck.js'
import { formatDate } from '@/utils/date.js'
import CheckDialog from '@/components/Dialog'
import CsvResulstDialog from '@/components/CsvResulstDialog'
import axios from 'axios'

export default {
  components: { MainLayout, CheckDialog, CsvResulstDialog },
  data () {
    return {
      sortRadio: 'asc',
      infoList: [],
      infoListStore: [],
      currentId: '',
      inputdata: '',
      options: [
        { id: '00000', name: 'すべて' },
        { id: '10000', name: '会員' },
        { id: '01000', name: 'ドライバー' },
        { id: '00100', name: '一般管理者' },
        { id: '00010', name: 'マスター管理者' },
        { id: '00001', name: '交通事業者' }
      ],
      isMember: 'false',

      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '',
        confirmButtonText: 'OK'
      },

      // 一览出力按钮按下否
      csvOutFlag: false,
      // 标题栏全选按钮按下否
      allChecked: false,

      // 下载CSV确认框属性
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      // 是否弹出确认框
      showPrintDialog: false,

      // 导入csv, 进度圈
      loadingFlag: false
    }
  },

  watch: {
    // 切换排序时重新显示数据  kana排序
    sortRadio (newvalue) {
      if (newvalue === 'asc') {
        this.infoList.sort((x, y) => {
          return (x.lastNamekana + x.firstNamekana).localeCompare(
            y.lastNamekana + y.firstNamekana
          )
        })
      } else {
        this.infoList.sort((x, y) => {
          return -(x.lastNamekana + x.firstNamekana).localeCompare(
            y.lastNamekana + y.firstNamekana
          )
        })
      }
      // accountSelectItem用来存储检索条件，便于再次返回时的一览界面
      sessionStorage.setItem('accountSelectItem', JSON.stringify({'inputdata': this.inputdata, 'currentId': this.currentId, 'sortRadio': this.sortRadio}))
    },
    // 切换下拉框时重新加载数据
    currentId (newvalue) {
      this.loadAllData(newvalue)
      sessionStorage.setItem('accountSelectItem', JSON.stringify({'inputdata': this.inputdata, 'currentId': this.currentId, 'sortRadio': this.sortRadio}))
    }
  },
  created: function () {
    // 初始化下拉框以及数据
    if (sessionStorage.getItem('accountSelectItem') !== null) {
      let accountSelectItemInfo = JSON.parse(sessionStorage.getItem('accountSelectItem'))
      this.inputdata = accountSelectItemInfo.inputdata
      this.currentId = accountSelectItemInfo.currentId
      this.sortRadio = accountSelectItemInfo.sortRadio
    } else {
      this.currentId = this.options[0].id
    }
  },
  methods: {
    // 根据类别和查询关键字后台请求数据
    loadAllData (currentType) {
      this.$axios
        .get('user/getUserInfoByType', {
          params: { type: currentType }
        })
        .then(response => {
          this.infoListStore = response.data.userInfoList
          this.infoList = response.data.userInfoList
          this.selectData()
          if (this.sortRadio === 'asc') {
            this.infoList.sort((x, y) => {
              return (x.lastNamekana + x.firstNamekana).localeCompare(
                y.lastNamekana + y.firstNamekana
              )
            })
          } else {
            this.infoList.sort((x, y) => {
              return -(x.lastNamekana + x.firstNamekana).localeCompare(
                y.lastNamekana + y.firstNamekana
              )
            })
          }
        })
        .catch(error => {
          // alert(error.response.status)
          // // 没通过拦截器则迁移到错误界面
          // // if (error === '401') { alert(error) }
          // if (error && error.response) {
          //   switch (error) {
          //     case 401: this.$router.push({ name: 'login' }); break
          //     // case 503: this.$router.push({ name: '错误画面' }); break 服务器不可用
          //     // default: alert(error)
          //   }
          // }
          console.log(error)
        })
    },
    // 查询框失去焦点或者enter键后请求数据
    selectData () {
      this.infoList = this.infoListStore.filter(item =>
        (item.lastName + item.firstName).includes(this.inputdata.trim().replace(' ', ''))
      )

      if (this.sortRadio === 'asc') {
        this.infoList.sort((x, y) => {
          return (x.lastNamekana + x.firstNamekana).localeCompare(
            y.lastNamekana + y.firstNamekana
          )
        })
      } else {
        this.infoList.sort((x, y) => {
          return -(x.lastNamekana + x.firstNamekana).localeCompare(
            y.lastNamekana + y.firstNamekana
          )
        })
      }
      sessionStorage.setItem('accountSelectItem', JSON.stringify({'inputdata': this.inputdata, 'currentId': this.currentId, 'sortRadio': this.sortRadio}))
    },
    // 跳转详细画面：参数为uid和是否为driver标记
    memberDetail (item) {
      sessionStorage.setItem('userInfoDetail', JSON.stringify(item))
      this.$router.push({ name: 'MemberListDetail' })
    },
    order (uid, name, namekana) {
      sessionStorage.setItem('userId', uid)
      this.$router.push({
        name: 'MemberListOrderAndDetail'
      })
      sessionStorage.setItem('historyUserName', JSON.stringify({ name: name, namekana: namekana }))
    },
    memberRegistration () {
      this.$router.push({ name: 'UserLogin' })
    },
    memberCheck (roleFlag) {
      return RoleFlagCheck.member(roleFlag)
    },
    driverCheck (roleFlag) {
      return RoleFlagCheck.diver(roleFlag)
    },
    generalManagerCheck (roleFlag) {
      return RoleFlagCheck.generalManager(roleFlag)
    },
    masterManagerCheck (roleFlag) {
      return RoleFlagCheck.masterManager(roleFlag)
    },
    transportCheck (roleFlag) {
      return RoleFlagCheck.transport(roleFlag)
    },

    // 选择文件后触发该事件
    readFile (event) {
      let errorList = []
      let self = this
      let params = []
      // 获取文件对象
      let file = event.target.files[0]
      // 文件读取器
      let reader = new FileReader()
      // 读取文件
      reader.readAsText(file, 'shift-jis')
      // 读取成功
      reader.onload = function () {        

        // 遍历文件行
        this.result.trim().split('\n').forEach(function (row, i) {
          // 去除标题行
          if (i !== 0) {
            // 遍历每行字段
            let fieldArrary = row.split(',')

            if (fieldArrary.length === 13) {
              // ユーザープロフィール情報
              let userProfileModel = {
                firstName: fieldArrary[2],
                lastName: fieldArrary[1],
                firstNameKana: fieldArrary[4],
                lastNameKana: fieldArrary[3],
                sex: fieldArrary[5],
                birthday: fieldArrary[6],
                homeAddress: fieldArrary[8],
                homeLat: '',
                homeLng: '',
                homeTelephone: fieldArrary[9],
                portableTelephone: fieldArrary[10],
                postalcode: fieldArrary[7],
                fax: fieldArrary[11],
                note: fieldArrary[12]
              }
              // ユーザーアカウント情報
              let userAccountModel = {
                roleFlag: fieldArrary[0],
                joinDate: formatDate(new Date(), 'yyyyMMdd')
              }

              if (userProfileModel.sex === '男性') {
                userProfileModel.sex = 0
              } else if (userProfileModel.sex === '女性') {
                userProfileModel.sex = 1
              } else if (userProfileModel.sex.trim() === '') {
                userProfileModel.sex = -1
              } else if (userProfileModel.sex !== '0' && userProfileModel.sex !== '1') {
                userProfileModel.sex = 2
              }

              // 権限チェック
              if(userAccountModel.roleFlag.length === 5){
                if(!RoleFlagCheck.transport(userAccountModel.roleFlag)){
                  params.push({
                    userProfile: userProfileModel,
                    userDriverProfile: null,
                    userAccount: userAccountModel
                  })
                }else{
                  errorList.push(i + 1 + '行目 CSVインポートで交通事業者を登録することはできません。手動で登録してください。')
                }
              }else{
                errorList.push(i + 1 + '行目 権限の文字数が不正です。半角数字5文字である必要があります。')
              }
            } else if (fieldArrary.length > 13) {
              errorList.push(i + 1 + '行目 項目数が不正です。適切な項目数は13ですが、入力された項目数は' + fieldArrary.length + '個でした。')
            } else if (fieldArrary.length < 13) {
              errorList.push(i + 1 + '行目 項目数が不正です。適切な項目数は13ですが、入力された項目数は' + fieldArrary.length + '個でした。')
            }
          }
        })

        if (errorList.length > 0) {
          self.showComfirmDialog(errorList)
        } else if (params.length > 0) {
          // 保存数据
          self.saveFileInfoToDb(params)
        }

        // 清空所选择的文件
        var file = document.getElementById('fileInput')
        file.value = ''
      }
    },

    // 保存文件数据到DB
    saveFileInfoToDb (params) {
      this.loadingFlag = true
      this.$axios
        .post('user/SaveUserInfoList', params)
        .then((response) => {
          let maxCount = response.data.statusList[0]
          let succeedCount = response.data.statusList[1]

          this.loadingFlag = false

          if (succeedCount === '0') {
            this.$refs.dialogWindow.success = false
            // 显示确认框`
            this.showComfirmDialog(response.data.errorMessage)
          } else {
            let succeedMessageList = []
            succeedMessageList.push('インポート成功：' + succeedCount + '件')
            this.$refs.dialogWindow.success = true
            // 显示确认框
            this.showComfirmDialog(succeedMessageList)
            // 数据保存成功 刷新List数据
            this.loadAllData(this.currentId)
          }
        })
        .catch((error) => {
          this.loadingFlag = false
          console.log(error)
        })
    },

    // 显示确认框
    showComfirmDialog (message) {
      if (message.length > 0) {
        this.$refs.dialogWindow.errorList = message
        this.showDialog = true
        this.$refs.dialogWindow
          .confirm()
          .then(() => {
            this.showDialog = false
          })
          .catch(() => {
            this.showDialog = false
          })
      }
    },

    monthWorkCount () {
      this.$router.push({ name: 'MonthWorkCount' })
    },

    downloadCsv () {
      // 显示checkBox和底部按钮
      this.csvOutFlag = true
    },

    // 出力
    doPrint () {
      // 打印列表
      let printList = []
      for (let i = 0; i < this.infoList.length; i++) {
        if (this.infoList[i].isChecked) {
          printList.push(this.infoList[i])
        }
      }

      // 根据是否勾选数据,弹出不同的确认框
      if (printList.length === 0) {
        let dialogPrintOption = {
          showNo: false,
          text: 'アカウントを選択してください。',
          confirmButtonText: 'OK'
        }
        this.dialogPrintOption = dialogPrintOption

        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          this.showPrintDialog = false
        })
          .catch(() => {
            this.showPrintDialog = false
          })
      } else {
        let dialogPrintOption = {
          showNo: true,
          text: 'データをダウンロードします。<br/>よろしいですか？',
          cancelButtonText: 'キャンセル',
          confirmButtonText: '実行'
        }
        this.dialogPrintOption = dialogPrintOption

        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          axios({
            method: 'post',
            url: 'user/downloadCsvFile',
            data: printList,
            responseType: 'blob'
          }).then(response => {
            let url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'アカウントリスト.csv')
            document.body.appendChild(link)
            link.click()
          }).catch((error) => {
            console.log(error)

            let dialogPrintOption = {
            showNo: false,
            text: '予期せぬエラーが発生しました。',            
            confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })
          })

          this.showPrintDialog = false
        }).catch(() => {
          this.showPrintDialog = false
        })
      }
    },
    // 取消
    cancelPrint () {
      // 不显示CheckBox
      this.csvOutFlag = false

      // 恢复到全部不勾选状态
      this.allChecked = false
      this.allCheckEvent()
    },
    // 全选
    allCheckEvent () {
      for (let i = 0; i < this.infoList.length; i++) {
        if (this.allChecked) {
          this.infoList[i].isChecked = true
        } else {
          this.infoList[i].isChecked = false
        }
      }
    },
    // 用来阻止冒泡: 防止点击checkBox后,跳转进入详细界面
    rowCheckBoxClickEvent () {
    },
    checkHomeLatLng (item) {
      if ((Math.abs(item.homeLat) < 0.0000000000000001) || (Math.abs(item.homeLng) < 0.0000000000000001)) {
        return true
      } else {
        return false
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // 路由离开前的操作
    const arr = ['/MovementStatus', '/MovementShift', '/RouteList', '/StationList', '/VehicleList', '/DriverList']
    arr.forEach(i => {
      if (to.path === i) {
        if (sessionStorage.getItem('accountSelectItem')) {
          sessionStorage.removeItem('accountSelectItem')
        }
      }
    })
    next()
  }
}
</script>

<template>
  <main-layout style="position: relative;">

    <div class="col-md-12 column" style="display:flex;flex-direction: column;flex:1;margin-bottom: 30px;margin-top:18px;position: relative;" v-loading="loadingFlag" element-loading-text="インポート中" element-loading-background="rgba(0, 0, 0, 0.2)">
      <div class="file-box">
        <input class="file-btn" id="fileInput" type="file" accept=".csv" @change="readFile" />
        <span class="upFile F2-M-19">CSVインポート</span>
      </div>

      <div class="row clearfix" style="flex:0 0 60px;position: relative;display:flex;flex-direction: row-reverse;">
        <div v-if="csvOutFlag" class="col-md-8 column F3-M-27" style="position: absolute;width: 100%;">
          [出力]アカウントリスト
        </div>
        <div v-else class="col-md-8 column F3-M-27" style="position: absolute;width: 100%;">
          アカウントリスト
        </div>
        <div class="col-md-4 column headerbtndiv">
          <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="monthWorkCount()"> 月次実績集計</button>
          <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="downloadCsv"> 一覧出力</button>
          <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="memberRegistration()">+ 新規登録</button>
        </div>
      </div>
      <div class="row clearfix conditiondiv" style="flex:0 0 45px;">
        <div class="col-md-6 inputdiv">
          <input type="text" title="検索" placeholder="検索" v-model="inputdata" @blur="selectData" @keydown.enter="selectData" />
        </div>
        <div class=" col-md-3  selectdiv">
          <select class="selectId" name="selectid" v-model="currentId">
            <option :value="optionobject.id" :key="optionobject.id" v-for="optionobject in options">{{optionobject.name}}</option>
          </select>
        </div>
        <div class=" col-md-2 radiodiv">
          <label class="radio-inline" style="float: left;">
            <input class="radiobtn" type="radio" name="memberIdRadio" v-model="sortRadio" id="ascRadio" value="asc">
            <span></span>
            <span class="F3-R-22"> 昇順</span>
          </label>
          <label class="radio-inline" style="float: left;">
            <input class="radiobtn" type="radio" name="memberIdRadio" v-model="sortRadio" id="dscRadio" value="dsc">
            <span></span>
            <span class="F3-R-22"> 降順</span>
          </label>
        </div>
      </div>
      <!-- 传参数传  item    220px  330px 160px-->
      <div class="table-container" style="flex: 1;">
        <div class=" table-header" style="padding-right:10px; flex:0 0 30px">
          <table>
            <thead>
              <tr class="theader bgc9 F2-R-15">
                <td class="trborder check-box" v-show="csvOutFlag">
                    <input type="checkbox" v-model="allChecked" style="height:20px;width:20px;margin-left:0px;" @change ="allCheckEvent">
                </td>
                <td class="trborder">氏名</td>
                <td class="trborder td-kana">カナ</td>
                <td class="trborder">アカウント ID</td>
                <td class="trborder td-tel">電話番号</td>
                <td class="trborder td-tel">携帯番号</td>
                <td class="trborder td-role">権限</td>
                <td class="td-gap"></td>
                <td></td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-body scrollbar">
          <table class="table">
            <tbody>
              <tr class="contenttr bgc5h" v-for='item in infoList' :key="item.uid">
                <td class="trborder check-box" v-show="csvOutFlag">
                      <input type="checkbox" v-model="item.isChecked" style="height:20px;width:20px;margin-left:0px;" @click.stop="rowCheckBoxClickEvent()">
                </td>
                <td class="trborder bodytext F3-R-19 member-name" @click="memberDetail(item)" :title="item.lastName+item.firstName">{{item.lastName}} {{item.firstName}}</td>
                <td class="trborder bodytext F3-R-19 td-kana  member-name" @click="memberDetail(item)"  :title="item.lastNamekana+item.firstNamekana">{{item.lastNamekana}} {{item.firstNamekana}}</td>
                <td class="trborder bodytext F3-R-19" @click="memberDetail(item)">{{item.loginId}}</td>
                <td class="trborder bodytext F3-R-19 td-tel" @click="memberDetail(item)">{{item.homeTelephone}}</td>
                <td class="trborder bodytext F3-R-19 td-tel" @click="memberDetail(item)">{{item.portableTelephone}}</td>
                <td class="trborder td-role" @click="memberDetail(item)">
                  <div class="role-div">
                    <div class="role-img">
                      <img src="../../assets/icon/member_status1.png" class="role-img" v-show="memberCheck(item.roleFlag)">
                    </div>
                    <div class="role-img">
                      <img src="../../assets/icon/member_status2.png" class="role-img" v-show="driverCheck(item.roleFlag)">
                      <img src="../../assets/icon/member_status5.png" class="role-img" v-show="transportCheck(item.roleFlag)">
                    </div>
                    <div class="role-img">
                      <img src="../../assets/icon/member_status3.png" class="role-img" v-show="generalManagerCheck(item.roleFlag)">
                      <img src="../../assets/icon/member_status4.png" class="role-img" v-show="masterManagerCheck(item.roleFlag)">
                    </div>
                  </div>
                </td>
                <td class="td-gap" @click="memberDetail(item)"><img v-show="checkHomeLatLng(item)"  src="../../assets/attention_mark_mid.png" class="role-img"></td>
                <td>
                  <div class="orderbtn-div" v-show="!csvOutFlag">
                    <button class="orderbtn F2-M-16 detailed-button" @click="order(item.uid,item.lastName+item.firstName,item.lastNamekana+item.firstNamekana)">予約 / 履歴</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <CsvResulstDialog v-show='showDialog' :dialog-option='dialogOption' ref='dialogWindow'></CsvResulstDialog>
    <CheckDialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></CheckDialog>
    <!--底部-->
      <div class="row clearfix" v-show="csvOutFlag">
          <div class="col-md-6 column">
              <button class="foot-button" style="float:right" @click="doPrint">出力</button>
          </div>
          <div class="col-md-6 column">
              <button class="foot-button" style="float:left" @click="cancelPrint">キャンセル</button>
          </div>
    </div>
  </main-layout>
</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
.name-strong {
    font-size: 30px;
}
.headerbtndiv {
    display: flex;
    flex-direction: row;
    float: right;
    // width: 420px;想要按钮固定式可以设置该div的宽度
}
.user-btn {
    float: right;
    margin-right: 5px;
    flex: 1;
    width: auto !important;
}
.conditiondiv {
    display: flex;
    flex-direction: row;
    flex: 0 0 45px;
}
.inputdiv {
    border: solid 2px #ccc;
    border-radius: 10px;
    width: 35%; //550px 35%
    //flex: 3;
    height: 45px;
    background: url(../../assets/select.png) no-repeat 10px center;
    margin-left: 150px; //150px
}
//width: 100%;
.inputdiv input {
    border: none;
    outline: none;
    background: none;
    width: 100%; //550px
    height: 45px;
    /* 可以对应调整.text中的backgroud和下面的text-indent调整图标和input输入地方的间距 */
    text-indent: 40px;
}
.selectdiv {
    border: solid 2px #ccc;
    border-radius: 10px;
    width: 25%; //390px  25%
    //flex: 2;
    height: 45px;
    margin-left: 15px;
}
.selectId {
    //background: none;
    border: none;
    outline: none;
    float: right;
    margin-right: -15px;
    height: 45px;
    width: 105%;
    text-indent: 1px;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: url("../../assets/dropselect.png") no-repeat scroll right center
        transparent;
}
.radiodiv {
    border-radius: 10px;
    width: 390px; //390px 25%
    height: 30px;
    //flex: 2;
    margin-left: 10px;
    margin-top: 6px;
    font-size: 20px;
}

.radiobtn {
    margin-top: 0px;
    height: 30px;
    width: 30px;
}

input[type="radio"] + span {
    display: inline-block;
    width: 10px;
    vertical-align: middle;
}
td {
    width: 13%;
}
.td-kana {
    width: 18%;
}
.td-tel {
    width: 14%;
}
.td-gap {
    width: 4%;
}
.role-div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 3px;
    margin-right: 3px;
    .role-img {
        width: 25px;
        height: 25px;
    }
}
.td-role {
    width: 115px;
}
.orderbtn-div {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.orderbtn {
    height: 30px;
    width: 110px;
    font-size: 18px;
    border: none;
    background-color: white;
    border-radius: 4px;
}
// tr:hover {
//     background-color: #c7dcdf;
//     cursor: pointer;
// }
.file-box {
  display: inline-block;
  position: absolute;
  padding: 3px 5px;
  overflow: hidden;
  color:#fff;
  background-color: #ccc;
  width: 160PX;
  height: 35PX;
  z-index: 10;

  background: linear-gradient(#a7a7a5 50%, #91928d 50%);
  border-radius: 20px;
}
.file-btn {
  cursor: pointer;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  outline: none;
  background-color: transparent;
  filter:alpha(opacity=0);
  -moz-opacity:0;
  -khtml-opacity: 0;
  opacity: 0;
}

.member-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.check-box{
  width: 4%;
}
</style>



// WEBPACK FOOTER //
// src/router/views/MemberList.vue